<template>
    <div class="factures-container">
        <div class="main-title">
            <span>
                {{ $t('facture.mainTitle') }}
            </span>
            <ReglePastille cle="facturation.definition" />
        </div>
        <div class="links">
            <router-link :to="{ path: '/facturation', query: $route.query }">{{ $t('facture.tab.late') }}</router-link>
            <router-link :to="{ path: '/facturation/echeance', query: $route.query }">{{ $t('facture.tab.duesoon') }}</router-link>
            <router-link :to="{ path: '/facturation/payee', query: $route.query }">{{ $t('facture.tab.payed') }}</router-link>
            <router-link to="/facturation/suivi" style="padding: 8px 16px;">{{ $t('facture.tab.suivi') }}</router-link>
        </div>
        <keep-alive :include="['ListFacturesEnRetard', 'ListFacturesAvantEcheance', 'ListFacturesPayees', 'SuiviFinancier']">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'ListFacturesPage',
    components: { ReglePastille },
});
</script>

<style scoped>
.main-title {
    color: var(--color-principal);
    margin-bottom: 16px;
    font-weight: 600;
    font-size: var(--font-size-large);
}
.factures-container {
    padding: 26px 26px 0;
}
.links {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
}
.links a {
    padding: 0.5rem 1.5rem;
    min-width: 160px;
    text-decoration: none;
    text-align: center;
    background-color: var(--white);
    color: var(--color-principal);
    margin-right: 1rem;
    border-radius: 6px;
    transition: background-color 0.2s;
}
.links .router-link-exact-active {
    background-color: var(--color-principal);
    color: var(--white);
}
</style>
